import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNotification } from '../Contexts/NotificationContext';

const FeaturedsFirst = () => {
    const { setNotification } = useNotification();
    const [lastFeatured, setLastFeatured] = useState(null);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchLastFeatured = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/destaques/`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();

                    setLastFeatured(data.ultimo_destaque);
                } else {
                    throw new Error('Erro ao buscar o destaque');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchLastFeatured();
    }, []);

    if (loading || !lastFeatured) return;

    return (
        <div className="group flex items-center shadow-lg overflow-hidden mt-20 mb-32">
            <Link
                to={`/painel/news/destaques/${lastFeatured.slug}`}
                className="relative w-1/2 overflow-hidden rounded-lg border-2 border-neutral-500"
            >
                <img src={lastFeatured.imagem} alt={lastFeatured.titulo} className="block w-full" />

                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent transition-all opacity-0 scale-y-125 group-hover:opacity-50 group-hover:scale-y-100" />
            </Link>
            <div className="p-6">
                <Link to={`/painel/news/destaques/${lastFeatured.slug}`}>
                    <h2 className="text-white text-4xl font-bold mb-2">{lastFeatured.titulo}</h2>
                </Link>
                <p className="max-w-lg text-lg text-gray-300">{lastFeatured.previa}</p>
                <Link to={`/painel/news/destaques/${lastFeatured.slug}`} className="block mt-8 text-white flex items-center gap-2">
                    ver mais
                    <span className="mt-0.5 w-2 h-2 border-r border-t border-white font-bold transition-all ease-out rotate-45 group-hover:translate-x-[5px]" />
                </Link>
            </div>
        </div>
    );
};

export default FeaturedsFirst;
